import extend from "../../services/extend";
import lazyScripts from "../../services/lazy-scripts";

/**
 * @ngdoc directive
 * @name vCaptcha
 */

export default (vue) => extend(vue, (vue) => {
    return {
        touchHandler: ('ontouchstart' in document.documentElement ? "touchstart" : "click"),
        endpoint: null,
        async init() {
            const container = document.createElement('div');
            container.className = 'recaptcha-container';
            container.style.display = 'none';
            vue.el.parentElement.appendChild(container);

            const callback = () => {
                //const form = scope.formId ? document.getElementById(scope.formId) : ;
                vue.el.closest('form').submit();
            };

            const recaptcha = await lazyScripts.loadRecaptcha();
            const widgetId = recaptcha.render(container, {
                sitekey: window.variables.recaptcha.siteKey,
                size: 'invisible',
                callback,
            }, true);

            vue.el.addEventListener(this.touchHandler, (e) => {
                e.preventDefault();
                recaptcha.reset(widgetId);
                recaptcha.execute(widgetId);
            });
        },
    }
});